import React, { useEffect, useState } from "react";
import CoreModal from "../../core/layouts/CoreModal";
import { Box, Grid, Icon } from "@mui/material";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import CoreFileUploader from "../../core/inputs/CoreFileUploader";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_POST } from "../../config/constants";
import {
  BILL_UPLOAD_ERROR,
  BILL_UPLOAD_SUCCESS,
} from "../../store/types/billTypes";
import {
  commonDocumentDownload,
  setBillReducer,
} from "../../store/actions/billActions";
import CoreRadioButton from "../../core/inputs/CoreRadioButton";

export default function CommonDocumentUpload() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const tool = location.pathname.split("/")[1];
  const [file, setFile] = useState(null);

  const [docType, setDocType] = useState("single-document-extractor");

  const [openModal, setOpenModal] = useState(false);

  const billUploadSuccess = useSelector(
    (state) => state?.bill?.billUploadSuccess,
  );
  const billUploadError = useSelector((state) => state?.bill?.billUploadError);
  const billUploadMessage = useSelector(
    (state) => state?.bill?.billUploadMessage,
  );

  useEffect(() => {
    if (file) {
      setOpenModal(false);
      handlePdfUpload();
    }
  }, [file]);

  useEffect(() => {
    if (billUploadSuccess) {
      dispatch(setBillReducer({ billUploadSuccess: false }));
      setDocType(null);
    }
    if (billUploadError) {
      alert(billUploadMessage);
      dispatch(setBillReducer({ billUploadError: false }));
      setDocType(null);
    }
  }, [billUploadSuccess, billUploadError]);

  const handleUpload = (event) => {
    event?.preventDefault();
    setOpenModal(false);
    dispatch(commonDocumentDownload(file, docType));
  };

  const handlePdfUpload = (e) => {
    setOpenModal(true);
  };

  return (
    <>
      <CoreModal
        open={openModal}
        handleClose={() => {
          setOpenModal(false);
        }}
        title={"What are you looking for?"}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: 16,
          }}
        >
          <Grid container>
            <Grid xs={8}>
              <CoreRadioButton
                orientation="vertical"
                onChange={(e) => {
                  setDocType(e.target.value);
                }}
                value={docType}
                options={[
                  {
                    label: "Extract text",
                    value: "single-document-extractor",
                  },
                  {
                    label: "Extract tabular data",
                    value: "table-extractor",
                  },
                ]}
              />
            </Grid>{" "}
            <Grid xs={4}>
              <CoreContainedButton
                onClick={handleUpload}
                style={{ marginTop: "38px" }}
              >
                Submit
              </CoreContainedButton>
            </Grid>
          </Grid>
        </Box>
      </CoreModal>
      <div
        style={{
          height: "calc(100vh - 68px - 4px)",
          width: "calc(100% + 32px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "-8px",
          marginTop: "-8px",
        }}
      >
        <CoreFileUploader
          tool={tool}
          handleChange={(file) => {
            if (file) {
              setFile(file);
            }
          }}
          isMulti={false}
          customHelperText="Supported documents : Upload any PDF or image."
        />
      </div>
    </>
  );
}
